import React from "react";
import { useApp } from "../context/AppContext";
import { lp } from "../lib/seo";
import { LEGAL_SLUGS } from "../lib/legal";

export const LegalConsent = ({ value, onChange, testId, dark = false }) => {
  const { t } = useApp();
  return (
    <div className={`space-y-2 text-xs ${dark ? "text-slate-300" : "text-slate-600"}`} data-testid={`${testId}-legal`}>
      {[["rental_terms_accepted", "rental"], ["privacy_policy_accepted", "privacy"]].map(([field, type]) => (
        <label key={field} className="flex items-start gap-2">
          <input type="checkbox" required checked={Boolean(value[field])} onChange={(e) => onChange({ ...value, [field]: e.target.checked })} data-testid={`${testId}-${type}-consent`} className="mt-0.5 h-4 w-4 shrink-0 accent-teal-700" />
          <span>{t.legal.consentPre}{" "}<a href={lp(`/${LEGAL_SLUGS[type]}`)} target="_blank" rel="noreferrer" data-testid={`${testId}-${type}-link`} className={`underline ${dark ? "text-teal-200" : "text-teal-700"}`}>{t.legal[type]}</a></span>
        </label>
      ))}
    </div>
  );
};
